import React from 'react'
import "../styles/footer.css"

const Footer = () => {
    return (
        <>
            <hr />
            <div className='footer'>
                2023 - &copy; Dipendra Singh, All Rights Reserved
            </div>
        </>
    )
}

export default Footer
